import React from "react";
import Price from "../price/Price";
import { Flame } from "lucide-react";

export default function InfoMeal({ isAvailable, calories, categoryIcon, price }) {
    return (
        <div className="flex flex-col items-center justify-center gap-3 px-4 py-4 bg-surface rounded-xl border border-accent shadow-md">

            {/* 🔥 Calorie (se presenti) */}
            {calories && (
                <div className="flex items-center gap-2">
                    <Flame className="w-4 h-4 text-primary" />
                    <span className="text-sm text-muted font-medium">{calories} kcal</span>
                </div>
            )}

            {/* 💶 Prezzo (sempre centrato) */}
            <Price
                price={price}
                isAvailable={isAvailable}
                categoryIcon={categoryIcon}
            />
        </div>
    );
}
